<template>
  <p>
    Após o pagamento da entrada, o restante da sua negociação poderá ser acompanhado diretamente no
    <a href="https://renegociacao.itau.com.br/" target="_blank" rel="noopener">portal de renegociação do Itaú</a>.
  </p>
</template>
